module.exports = __webpack_public_path__ + "img/Mobile QR.png";